module.exports = {
    handle: (e, data) => {           
        console.log('search:handler');
    }
}